import type {
  CaseDocument,
  FilingDetail,
} from '@/modules/tools/bankruptcy/stores/types'
import { ConvertCard } from './ConvertCard'
import { DocumentsSummary } from './DocumentsSummary'
import { ReviewResults } from './ReviewResults'

export const CaseReview = ({
  filing,
  documents,
  isBusy,
  onRescreen,
}: {
  filing: FilingDetail
  documents: CaseDocument[]
  isBusy: boolean
  onRescreen: () => void
}) => {
  const frozen = !!filing.project

  return (
    <>
      <DocumentsSummary filing={filing} documents={documents} frozen={frozen} />
      <ReviewResults
        filing={filing}
        onRescreen={onRescreen}
        canRescreen={!frozen}
        isBusy={isBusy}
      />
      <ConvertCard filing={filing} />
    </>
  )
}
